import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters, initialDateFilters }) => {

    const hasValue = (value) => String(value ?? '').trim() !== ``;

    const identificationFilterChange = (field, value) => {
        setFilters(prev => {

            const nextFilters = {...prev, [field]: value};
            const clearDates = hasValue(nextFilters.dispatchId) || hasValue(nextFilters.numberCheckBook);

            return {
                ...nextFilters,
                ...(clearDates ? {dtStart: null, dtEnd: null} : initialDateFilters())
            };
        });
    };

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                        <InputDateTime
                            id="dtStart"
                            label={`Data/hora inicial ${hasValue(filters.numberCheckBook) || hasValue(filters.dispatchId) ? '' : '*'}`}
                            selected={filters.dtStart}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                            disabled={hasValue(filters.numberCheckBook) || hasValue(filters.dispatchId)}
                        />

                        <InputDateTime
                            id="dtEnd"
                            label={`Data/hora final ${hasValue(filters.numberCheckBook) || hasValue(filters.dispatchId) ? '' : '*'}`}
                            selected={filters.dtEnd}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                            disabled={hasValue(filters.numberCheckBook) || hasValue(filters.dispatchId)}
                        />

                        <InputForm
                            id="dispatchId"
                            label="ID"
                            value={filters.dispatchId}
                            onChange={({target}) => {identificationFilterChange('dispatchId', target.value)}}
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />

                        <InputForm
                            id="numberCheckBook"
                            label="Talão"
                            value={filters.numberCheckBook}
                            onChange={({target}) => {identificationFilterChange('numberCheckBook', target.value)}}
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />

                        <SelectComponent
                            id={'action'}
                            label='Ação'
                            isMulti={false}
                            options={[
                                {label: "Todos", value: 'all'},
                                {label: "Cadastro", value: 'create'},
                                {label: "Alteração", value: 'update'},
                                {label: "Exclusão", value: 'delete'},
                                {label: "Visualização", value: 'view'}
                            ]}
                            value={filters.action}
                            onChange={(value) => setFilters(prev => ({...prev, action: value}))}
                            classNameWrapper={"w-full"}
                            isClearable={false}
                        />

                    <AccessForm filters={filters} setFilters={setFilters}/>

                </form>
            </div>
        </>
    );
};

export default Filters;